import type { LoanEmploymentPaymentSchedule } from '@/types/LoanApplicationType';

export const EMPLOYMENT_PAY_SCHEDULE_LABELS: Record<
  Exclude<LoanEmploymentPaymentSchedule, ''>,
  string
> = {
  hourly: 'Hourly',
  daily: 'Daily',
  weekly: 'Weekly',
  bi_weekly: 'Bi-weekly',
  semi_monthly: 'Semi-monthly',
  monthly: 'Monthly',
};

/**
 * Converts pay rate or gross per pay period to estimated gross monthly income.
 */
export function grossMonthlyFromPaySchedule(
  schedule: LoanEmploymentPaymentSchedule,
  opts: {
    /** Hourly rate when schedule is hourly; otherwise gross per pay period. */
    amount: number;
    hoursPerWeek?: number | null;
    workDaysPerWeek?: number | null;
  }
): number | null {
  const { amount } = opts;
  if (!schedule || !Number.isFinite(amount) || amount < 0) return null;

  const hoursPerWeek = Number(opts.hoursPerWeek);
  const hpw =
    Number.isFinite(hoursPerWeek) && hoursPerWeek > 0 ? hoursPerWeek : 40;

  const workDays = Number(opts.workDaysPerWeek);
  const dpw = Number.isFinite(workDays) && workDays > 0 ? workDays : 5;

  switch (schedule) {
    case 'hourly':
      return Math.round((amount * hpw * 52) / 12);
    case 'daily':
      return Math.round((amount * dpw * 52) / 12);
    case 'weekly':
      return Math.round((amount * 52) / 12);
    case 'bi_weekly':
      return Math.round((amount * 26) / 12);
    case 'semi_monthly':
      return Math.round(amount * 2);
    case 'monthly':
      return Math.round(amount);
    default:
      return null;
  }
}
